// import { LoadingButton } from "@mui/lab";
// import { Button, Card, CardContent, Grid, Typography, Box, Divider, Chip } from "@mui/material";
// import { useForm } from "react-hook-form";
// import { FormProvider, RHFFileField, RHFSelectField, RHFTextField } from "../../common/hook-form";
// import UploadIcon from '@mui/icons-material/Upload';
// import { apiConstants, patchGeneric, post } from "../../common/constants";
// import { useSnackbar } from "notistack";
// import { useState } from "react";

// function UploadLogo(props) {
//     const { merchantId, setReload, setLabelOpen } = props
//     const methods = useForm({
//         defaultValues: {
//             name: '',
//             configValue: '',
//             format: '',
//             type: ''
//         }
//     })
//     const { handleSubmit, watch, reset } = methods
//     const { enqueueSnackbar } = useSnackbar();
//     const [activeTab, setActiveTab] = useState('standard')
//     const [isLoading, setIsLoading] = useState(false)

//     const list = [
//         { label: 'Image URL', value: 'url' },
//         { label: 'Image File', value: 'file' }
//     ]
//     const uploadType = [
//         { label: 'Email Logo', value: 'Email' },
//         { label: 'Shipping Label Logo', value: 'Label' }
//     ]

//     const format = watch('format')
//     const typeOfUpload = watch('type')

//     const onSubmit = async (data) => {
//         setIsLoading(true)
//         try {
//             if (format === "file" && typeOfUpload === "Label") {
//                 let formData = new FormData()
//                 formData.append('attachments[]', data.file[0]);
//                 formData.append('folder', data?.folder)
//                 const res = await post(`${apiConstants.UPLOAD_LOGO_IMAGE}`, formData)
//                 if (res.status === 200) {
//                     await uploadUrl(res.data[0])
//                 }
//             }
//             if (format === "url" && typeOfUpload === "Label") {
//                 await uploadUrl(data.configValue)
//             }
//             if (format === "file" && typeOfUpload === "Email") {
//                 let formData = new FormData()
//                 formData.append('attachments[]', data.file[0]);
//                 formData.append('folder', 'email')
//                 const res = await post(`${apiConstants.UPLOAD_LOGO_IMAGE}`, formData)
//                 if (res.status === 200) {
//                     await uploadEmaiLogo(res.data[0])
//                 }
//             }
//             if (format === "url" && typeOfUpload === "Email") {
//                 await uploadEmaiLogo(data.configValue)
//             }
//             reset()
//         } catch (err) {
//             enqueueSnackbar(err.response?.data?.message ? err.response?.data?.message : "Some error occurred", { variant: 'error' })
//         } finally {
//             setIsLoading(false)
//         }
//     }

//     const uploadUrl = async (url) => {
//         try {
//             const payload = {
//                 "configs": [
//                     {
//                         "enabled": true,
//                         "configKey": "udf_1",
//                         "configDesc": "Logo url",
//                         "configValue": url,
//                         "valueDatatype": "String"
//                     }
//                 ]
//             }
//             const res = await post(`${apiConstants.MERCHANT_DETAILS}/${merchantId}/shippinglabel`, payload)
//             if (res.status === 200) {
//                 setLabelOpen(false)
//                 setReload(reload => reload + 1)
//                 enqueueSnackbar("Logo Updated Successfully", { variant: 'success' })
//             }
//         } catch (err) {
//             enqueueSnackbar(err.response?.data?.message ? err.response?.data?.message : "Some error occurred", { variant: 'error' })
//         }
//     }

//     const uploadEmaiLogo = async (imageURL) => {
//         const data = {
//             id: merchantId,
//             test_merchant: false,
//             emailMerchantLogo: imageURL
//         }
//         try {
//             const response = await patchGeneric(apiConstants.MERCHANT_UPDATE, data)
//             if (response.status === 204) {
//                 enqueueSnackbar('Merchant details successfully updated!', { variant: 'success' })
//                 setLabelOpen(false)
//                 setReload(reload => reload + 1)
//             }
//         } catch (err) {
//             enqueueSnackbar(err.response?.data?.message ? err.response?.data?.message : "Some error occurred", { variant: 'error' })
//         }
//     }

//     return (
//         <Card sx={{ boxShadow: 2 }}>
//             <CardContent sx={{ p: 3 }}>
//                 {/* Tab Navigation */}
//                 <Box sx={{ mb: 3 }}>
//                     {/* Helpful Note */}
//                     <Box sx={{ 
//                         p: 2, 
//                         bgcolor: 'grey.50', 
//                         borderRadius: 1, 
//                         border: '1px solid',
//                         borderColor: 'grey.200'
//                     }}>
//                         <Typography variant="body2" color="textSecondary" sx={{ mb: 1, fontWeight: 500 }}>
//                             📝 Upload Guide:
//                         </Typography>
//                         <Typography variant="body2" color="textSecondary" sx={{ mb: 0.5 }}>
//                             • <strong>Standard Upload:</strong> Use this for regular merchant logos (non-Shopify stores)
//                         </Typography>
//                         <Typography variant="body2" color="textSecondary" sx={{ mb: 0.5 }}>
//                             • <strong>Shopify Upload:</strong> Use this specifically for Shopify store logos with special naming conventions
//                         </Typography>
//                         <Typography variant="body2" color="textSecondary">
//                             • <strong>Email Logo:</strong> Logo used in email templates | <strong>Shipping Label Logo:</strong> Logo used on shipping labels
//                         </Typography>
//                     </Box>
//                     <Box sx={{ display: 'flex', gap: 1, mt: 2 }}>
//                         <Chip
//                             label="Standard Upload"
//                             onClick={() => setActiveTab('standard')}
//                             color={activeTab === 'standard' ? 'warning' : 'default'}
//                             variant={activeTab === 'standard' ? 'filled' : 'outlined'}
//                             sx={{ cursor: 'pointer' }}
//                         />
//                         <Chip
//                             label="Shopify Upload"
//                             onClick={() => setActiveTab('shopify')}
//                             color={activeTab === 'shopify' ? 'warning' : 'default'}
//                             variant={activeTab === 'shopify' ? 'filled' : 'outlined'}
//                             sx={{ cursor: 'pointer' }}
//                         />
//                     </Box>
//                 </Box>

//                 <Divider sx={{ mb: 3 }} />

//                 {/* Form Content */}
//                 {activeTab === 'standard' ? (
//                     <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
//                         <Grid container spacing={3}>
//                             <Grid item xs={12} md={6}>
//                                 <RHFSelectField
//                                     name="type"
//                                     label="Upload Type"
//                                     width="100%"
//                                     required
//                                     options={uploadType}
//                                 />
//                             </Grid>
//                             <Grid item xs={12} md={6}>
//                                 <RHFSelectField
//                                     name="format"
//                                     label="Upload Format"
//                                     width="100%"
//                                     required
//                                     options={list}
//                                 />
//                             </Grid>

//                             {format === "file" && (
//                                 <>
//                                     <Grid item xs={12}>
//                                         <RHFFileField 
//                                             name="file" 
//                                             required 
//                                             label="Select Image File"
//                                         />
//                                     </Grid>
//                                     {typeOfUpload === "Label" && (
//                                         <Grid item xs={12}>
//                                             <RHFTextField
//                                                 name="folder"
//                                                 label="Folder Name"
//                                                 placeholder="Enter folder name for organization"
//                                                 required
//                                             />
//                                         </Grid>
//                                     )}
//                                 </>
//                             )}

//                             {format === "url" && (
//                                 <Grid item xs={12}>
//                                     <RHFTextField
//                                         name="configValue"
//                                         label="Image URL"
//                                         placeholder="https://example.com/logo.png"
//                                         multiline
//                                         rows={3}
//                                         required
//                                     />
//                                 </Grid>
//                             )}

//                             <Grid item xs={12}>
//                                 <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
//                                     <LoadingButton
//                                         variant="contained"
//                                         size="medium"
//                                         startIcon={<UploadIcon />}
//                                         disabled={!format || isLoading}
//                                         loading={isLoading}
//                                         type="submit"
//                                     >
//                                         Upload Logo
//                                     </LoadingButton>
//                                     <Button
//                                         variant="outlined"
//                                         onClick={() => reset()}
//                                         disabled={isLoading}
//                                     >
//                                         Reset Form
//                                     </Button>
//                                 </Box>
//                             </Grid>
//                         </Grid>
//                     </FormProvider>
//                 ) : (
//                     <UploadShopifyLogo 
//                         merchantId={merchantId} 
//                         setReload={setReload} 
//                         setLabelOpen={setLabelOpen} 
//                     />
//                 )}
//             </CardContent>
//         </Card>
//     )
// }

// export default UploadLogo;

// function UploadShopifyLogo(props) {
//     const { merchantId, setReload, setLabelOpen } = props
//     const methods = useForm({
//         defaultValues: {
//             name: '',
//             configValue: '',
//             format: '',
//             type: ''
//         }
//     })
//     const { handleSubmit, watch, reset } = methods
//     const { enqueueSnackbar } = useSnackbar();
//     const [isLoading, setIsLoading] = useState(false)

//     const list = [
//         { label: 'Image URL', value: 'url' },
//         { label: 'Image File', value: 'file' }
//     ]
//     const uploadType = [
//         { label: 'Email Logo', value: 'Email' },
//         { label: 'Shipping Label Logo', value: 'Label' }
//     ]

//     const format = watch('format')
//     const typeOfUpload = watch('type')

//     const onSubmit = async (data) => {
//         setIsLoading(true)
//         try {
//             if (format === "file" && typeOfUpload === "Label") {
//                 let formData = new FormData()
//                 formData.append('attachments[]', data.file[0]);
//                 formData.append('folder', data?.folder)
//                 const res = await post(`${apiConstants.UPLOAD_LOGO_IMAGE}`, formData)
//                 if (res.status === 200) {
//                     await uploadUrl(res.data[0], data.name)
//                 }
//             }
//             if (format === "url" && typeOfUpload === "Label") {
//                 await uploadUrl(data.configValue, data.name)
//             }
//             if (format === "file" && typeOfUpload === "Email") {
//                 let formData = new FormData()
//                 formData.append('attachments[]', data.file[0]);
//                 formData.append('folder', 'email')
//                 const res = await post(`${apiConstants.UPLOAD_LOGO_IMAGE}`, formData)
//                 if (res.status === 200) {
//                     await uploadEmaiLogo(res.data[0])
//                 }
//             }
//             if (format === "url" && typeOfUpload === "Email") {
//                 await uploadEmaiLogo(data.configValue)
//             }
//             reset()
//         } catch (err) {
//             enqueueSnackbar(err.response?.data?.message ? err.response?.data?.message : "Some error occurred", { variant: 'error' })
//         } finally {
//             setIsLoading(false)
//         }
//     }

//     const uploadUrl = async (data, name) => {
//         try {
//             const payload = {
//                 "configs": [
//                     {
//                         "enabled": true,
//                         "configKey": "udf_1",
//                         "configDesc": `ImageSHOPIFY_${name}`,
//                         "configValue": data.url,
//                         "valueDatatype": "String"
//                     }
//                 ]
//             }
//             const res = await post(`${apiConstants.MERCHANT_DETAILS}/${merchantId}/shippinglabel`, payload)
//             if (res.status === 200) {
//                 setLabelOpen(false)
//                 setReload(reload => reload + 1)
//                 enqueueSnackbar("Shopify Logo Updated Successfully", { variant: 'success' })
//             }
//         } catch (err) {
//             enqueueSnackbar(err.response?.data?.message ? err.response?.data?.message : "Some error occurred", { variant: 'error' })
//         }
//     }

//     const uploadEmaiLogo = async (imageURL) => {
//         const data = {
//             id: merchantId,
//             test_merchant: false,
//             emailMerchantLogo: imageURL
//         }
//         try {
//             const response = await patchGeneric(apiConstants.MERCHANT_UPDATE, data)
//             if (response.status === 204) {
//                 enqueueSnackbar('Shopify merchant details successfully updated!', { variant: 'success' })
//                 setLabelOpen(false)
//                 setReload(reload => reload + 1)
//             }
//         } catch (err) {
//             enqueueSnackbar(err.response?.data?.message ? err.response?.data?.message : "Some error occurred", { variant: 'error' })
//         }
//     }

//     return (
//         <Box>
//             <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 500 }}>
//                 Shopify Logo Configuration
//             </Typography>
//             <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
//                 <Grid container spacing={3}>
//                     <Grid item xs={12} md={6}>
//                         <RHFSelectField
//                             name="type"
//                             label="Upload Type"
//                             width="100%"
//                             required
//                             options={uploadType}
//                         />
//                     </Grid>
//                     <Grid item xs={12} md={6}>
//                         <RHFSelectField
//                             name="format"
//                             label="Upload Format"
//                             width="100%"
//                             required
//                             options={list}
//                         />
//                     </Grid>

//                     {format === "file" && (
//                         <>
//                             <Grid item xs={12}>
//                                 <RHFFileField 
//                                     name="file" 
//                                     required 
//                                     label="Select Shopify Logo File"
//                                 />
//                             </Grid>
//                             {typeOfUpload === "Label" && (
//                                 <Grid item xs={12}>
//                                     <RHFTextField
//                                         name="folder"
//                                         label="Folder Name"
//                                         placeholder="Enter folder name for Shopify logo"
//                                         required
//                                     />
//                                 </Grid>
//                             )}
//                         </>
//                     )}
//                     {format === "url" && (
//                         <>
//                         <Grid item xs={12}>
//                             <RHFTextField
//                                 name="name"
//                                 label="Store Name"
//                                 placeholder="Enter Store Name"
//                                 required
//                             />
//                         </Grid>
//                         <Grid item xs={12}>
//                             <RHFTextField
//                                 name="configValue"
//                                 label="Shopify Logo URL"
//                                 placeholder="https://example.com/shopify-logo.png"
//                                 multiline
//                                 rows={3}
//                                 required
//                             />
//                         </Grid>
//                         </>
//                     )}

//                     <Grid item xs={12}>
//                         <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
//                             <LoadingButton
//                                 variant="contained"
//                                 size="medium"
//                                 startIcon={<UploadIcon />}
//                                 disabled={!format || isLoading}
//                                 loading={isLoading}
//                                 type="submit"
//                             >
//                                 Upload Shopify Logo
//                             </LoadingButton>
//                             <Button
//                                 variant="outlined"
//                                 onClick={() => reset()}
//                                 disabled={isLoading}
//                             >
//                                 Reset Form
//                             </Button>
//                         </Box>
//                     </Grid>
//                 </Grid>
//             </FormProvider>
//         </Box>
//     )
// }

import { LoadingButton } from "@mui/lab";
import { Card, CardContent, Grid } from "@mui/material";
import { useForm } from "react-hook-form";
import { FormProvider, RHFFileField, RHFSelectField, RHFTextField } from "../../common/hook-form";
import UploadIcon from '@mui/icons-material/Upload';
import { apiConstants, patchGeneric, post } from "../../common/constants";
import { useSnackbar } from "notistack";

function UploadLogo(props) {
    const { merchantId, setReload, setLabelOpen, logoType = 'default' } = props
    const methods = useForm({
        defaultValues: {
            type: logoType !== 'default' ? 'Label' : '',
            format: '',
            configDesc: '',
            configValue: '',
            file: null
        }
    })
    const { handleSubmit, watch } = methods
    const { enqueueSnackbar } = useSnackbar();
    const list = [
        { label: 'Image URL', value: 'url' },
        { label: 'Image File', value: 'file' }
    ]
    const uploadType = [
        { label: 'Email', value: 'Email' },
        { label: 'Label', value: 'Label' }
    ]
    // const orderTypeList = [

    //     { label: 'Shopify', value: 'shopify' },
    //     { label: 'Other', value: 'other' }
    // ]

    const format = watch('format')
    const typeOfUpload = watch('type')
    // const orderType = watch('orderType')

    const onSubmit = async (data) => {
        try {
            if (format === "file" && typeOfUpload === "Label") {
                let formData = new FormData()
                formData.append('attachments[]', data.file[0]);
                formData.append('folder', data?.folder)
                const res = await post(`${apiConstants.UPLOAD_LOGO_IMAGE}`, formData)
                if (res.status === 200) {
                    uploadUrl(res.data[0], data.configDesc)
                }
            }
            if (format === "url" && typeOfUpload === "Label") {
                uploadUrl(data.configValue, data.configDesc)
            }
            if (format === "file" && typeOfUpload === "Email") {
                let formData = new FormData()
                formData.append('attachments[]', data.file[0]);
                formData.append('folder', 'email')
                const res = await post(`${apiConstants.UPLOAD_LOGO_IMAGE}`, formData)
                if (res.status === 200) {
                    uploadEmaiLogo(res.data[0])
                }
            }
            if (format === "url" && typeOfUpload === "Email") {
                uploadEmaiLogo(data.configValue)
            }
        } catch (err) {
            enqueueSnackbar(err.response?.data?.message ? err.response?.data?.message : "Some error occurred", { variant: 'error' })
        }
    }

    const uploadUrl = async (url, configDesc = '') => {
        try {
            const payload = {
                "enabled": true,
                "configKey": "udf_1",
                // "configDesc": orderType === "shopify" ? "ImageSHOPIFY_Logo url" : "Logo url",
                "configDesc": logoType === 'default' ? "Logo url" : `ImageSHOPIFY_${configDesc}`,
                "configValue": url,
                "valueDatatype": "String"
            }
            const res = await post(`${apiConstants.MERCHANT_DETAILS}/${merchantId}/shippinglabel`, payload)
            if (res.status === 200) {
                setLabelOpen(false)
                setReload(reload => reload + 1)
                enqueueSnackbar("Logo Updated Successfully", { variant: 'success' })
            }
        } catch (err) {
            enqueueSnackbar(err.response?.data?.message ? err.response?.data?.message : "Some error occurred", { variant: 'error' })
        }
    }

    const uploadEmaiLogo = async (imageURL) => {
        const data = {
            id: merchantId,
            test_merchant: false,
            emailMerchantLogo: imageURL
        }
        try {
            const response = await patchGeneric(apiConstants.MERCHANT_UPDATE, data)
            if (response.status === 204) {
                enqueueSnackbar('Merchant details successfully updated!', { variant: 'success' })
                setLabelOpen(false)
                setReload(reload => reload + 1)
            }
        } catch (err) {
            enqueueSnackbar(err.response?.data?.message ? err.response?.data?.message : "Some error occurred", { variant: 'error' })
        }
    }

    return (
        <Card>
            <CardContent>
                <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
                    <Grid container spacing={2}>
                        {logoType === 'default' && (
                            <Grid item xs={6}>
                                <RHFSelectField
                                    name="type"
                                    label="Select Upload Type (Email or Shipping Label)"
                                    width="100%"
                                    required
                                    options={uploadType}
                                />
                            </Grid>
                        )}
                        {logoType === 'webstore' && (
                            <>
                                <Grid item xs={6}>
                                    <RHFTextField
                                        name="configDesc"
                                        label="Store Name"
                                        placeholder="Enter Store Name"
                                        required
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <RHFTextField
                                        name="type"
                                        label="Upload Type"
                                        value="Label"
                                        disabled
                                        helperText="Automatically set to Label for webstore uploads"
                                    />
                                </Grid>
                            </>
                        )}
                        {/* <Grid item xs={6}>
                            <RHFSelectField
                                name="orderType"
                                label="Select Order Type"
                                width="100%"
                                required
                                options={orderTypeList}
                            />
                        </Grid> */}
                        <Grid item xs={6}>
                            <RHFSelectField
                                name="format"
                                label="Select Upload Format"
                                width="100%"
                                required
                                options={list}
                            />
                        </Grid>

                        {format === "file" && (
                            <>
                                <Grid item xs={12}>
                                    <RHFFileField name="file" required />
                                </Grid>
                                {/* {typeOfUpload === "Label" && (
                                    <Grid item xs={12}>
                                        <RHFTextField
                                            name="folder"
                                            label="Please provide folder name"
                                        />
                                    </Grid>
                                )} */}
                            </>
                        )}

                        {format === "url" && (
                            <Grid item xs={6}>
                                <RHFTextField
                                    name="configValue"
                                    label="URL"
                                    multiline
                                    required
                                />
                            </Grid>
                        )}
                        <Grid item xs={12}>
                            <LoadingButton
                                variant="contained"
                                size="medium"
                                startIcon={<UploadIcon />}
                                disabled={format !== "file" && format !== "url"}
                                type="submit"
                            >
                                Upload
                            </LoadingButton>
                        </Grid>
                    </Grid>
                </FormProvider>
            </CardContent>
        </Card>
    )
}

export default UploadLogo;